import { RadioContainerGroup, RadioContainerItem } from './components';

export const RadioContainer = {
  Group: RadioContainerGroup,
  Item: RadioContainerItem,
};
